
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Luxurycarrentalinpune() {



    const cardData =
    {
        keyword: 'Luxury Car Rentals in Pune ',
        heading: 'etravo : Luxury Car Rentals in Pune',



"headingDescription": "eTravo offers premium Luxury Car Rental Services in Pune, designed for executives, corporate clients, weddings, VIP transfers, airport travel, and special occasions. With a selection of high-end cars and luxury SUVs, along with professional chauffeur services, eTravo provides a smooth, stylish, and comfortable travel experience. Whether you need a luxury car for a business meeting, airport pickup, wedding, corporate event, or outstation journey, eTravo delivers reliable and convenient premium transportation across Pune.",

"top": "Top Luxury Car Rental Services in Pune with eTravo",

"topPlaces": [
  {
    "title": "Koregaon Park Luxury Zone",
    "description": "A premium locality in Pune known for upscale hotels, restaurants, and corporate residences, making it a key demand area for luxury chauffeur-driven cars."
  },
  {
    "title": "Viman Nagar Airport Corridor",
    "description": "Located near Pune Airport, this area is a major hub for VIP transfers, business travel, and luxury airport pickup and drop services."
  },
  {
    "title": "Kalyani Nagar Business District",
    "description": "A high-end commercial and residential zone with corporate offices and luxury stays, requiring premium car rental services."
  },
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub where senior executives and corporate leaders often use luxury car rentals for business travel and meetings."
  },
  {
    "title": "Baner-Balewadi Corporate Hub",
    "description": "A fast-growing business district with startups, MNC offices, and high-end residences requiring executive and luxury transport services."
  },
  {
    "title": "Magarpatta City",
    "description": "A premium IT township where corporate leaders and clients frequently use luxury chauffeur-driven cars for meetings and events."
  },
  {
    "title": "Hadapsar Business Zone",
    "description": "An important commercial and IT region where luxury cars are used for corporate travel and client transportation."
  },
  {
    "title": "Shivajinagar Central Business Area",
    "description": "A key administrative and business district where luxury rentals are used for official and executive travel needs."
  },
  {
    "title": "Pimpri-Chinchwad Industrial Corridor",
    "description": "A major industrial zone where senior management and corporate guests often prefer premium car rentals for travel."
  },
  {
    "title": "Wakad Residential IT Belt",
    "description": "A key residential area for IT professionals where luxury rentals are used for special occasions, events, and executive travel."
  }
],


"services": [
{
"name": "Luxury Car Rental Pune",
"description": "eTravo offers luxury car rental in Pune for customers seeking premium travel experiences. Our high-end vehicles provide unmatched comfort, style, and performance, making them perfect for corporate travel, special occasions, and personal use."
},
{
"name": "Premium Car Hire Pune",
"description": "Experience top-class travel with eTravo’s premium car hire services in Pune. Our fleet includes well-maintained luxury vehicles driven by professional chauffeurs, ensuring a smooth and elegant journey."
},
{
"name": "Luxury Cab Service Pune",
"description": "eTravo provides luxury cab services in Pune designed for those who value comfort and sophistication. Our service ensures punctual pickups, plush interiors, and a premium travel experience for every ride."
},
{
"name": "High End Car Rental Pune",
"description": "Our high-end car rental services in Pune offer premium vehicles for business and leisure travel. eTravo ensures quality service, advanced features, and a comfortable ride for elite customers."
},
{
"name": "Executive Car Hire Pune",
"description": "eTravo offers executive car hire services in Pune for corporate professionals and VIP clients. Our vehicles provide privacy, comfort, and a refined travel experience for meetings and business events."
},
{
"name": "Luxury Vehicle Rental Pune",
"description": "eTravo provides luxury vehicle rental services in Pune with a range of premium cars suitable for all high-end travel needs. Our service ensures elegance, reliability, and superior comfort."
},
{
"name": "Premium Taxi Pune",
"description": "Our premium taxi services in Pune deliver a superior travel experience with high-quality vehicles and professional drivers. eTravo ensures comfort, punctuality, and style for every journey."
},
{
"name": "Luxury Travel Cars Pune",
"description": "eTravo offers luxury travel cars in Pune designed for comfortable and stylish journeys. Whether for business or personal travel, our vehicles ensure a premium experience."
},
{
"name": "High Class Car Rental Pune",
"description": "Our high-class car rental services in Pune provide elegant vehicles for customers seeking luxury and comfort. eTravo ensures a refined travel experience with well-maintained cars and expert drivers."
},
{
"name": "Luxury Sedan Hire Pune",
"description": "eTravo offers luxury sedan hire in Pune for smooth and comfortable travel. Our sedans are ideal for corporate travel, airport transfers, and premium city rides."
},
{
"name": "Premium SUV Rental Pune",
"description": "Experience powerful and comfortable travel with eTravo’s premium SUV rental services in Pune. Our SUVs provide spacious interiors and advanced features for a superior journey."
},
{
"name": "Corporate Luxury Cars Pune",
"description": "eTravo provides corporate luxury car services in Pune for executive and VIP travel. Our premium vehicles ensure professionalism, comfort, and an impressive travel experience for business needs."
},
{
"name": "Wedding Luxury Car Pune",
"description": "Make your special day memorable with eTravo’s wedding luxury car services in Pune. Our elegant vehicles add style and sophistication to weddings and special occasions."
},
{
"name": "VIP Car Rental Pune",
"description": "eTravo offers VIP car rental services in Pune for high-profile clients and special events. Our service ensures premium vehicles, professional chauffeurs, and a luxurious travel experience."
},
{
"name": "Luxury Car Booking Pune",
"description": "eTravo makes luxury car booking in Pune simple and convenient. With flexible options and premium vehicles, our service ensures a seamless and comfortable travel experience."
}
],
"tableData": [
["Luxury Car Rental Pune", "Premium Car Hire Pune"],
["Luxury Cab Service Pune", "High End Car Rental Pune"],
["Executive Car Hire Pune", "Luxury Vehicle Rental Pune"],
["Premium Taxi Pune", "Luxury Travel Cars Pune"],
["High Class Car Rental Pune", "Luxury Sedan Hire Pune"],
["Premium SUV Rental Pune", "Corporate Luxury Cars Pune"],
["Wedding Luxury Car Pune", "VIP Car Rental Pune"],
["Luxury Car Booking Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Premium Luxury Car Rentals in Pune for Elite Travel",
      "WhyChoosedescription": "eTravo offers high-end luxury car rentals in Pune, providing a premium travel experience for corporate executives, VIP guests, weddings, and special occasions with unmatched comfort and style."
    },
    {
      "WhyChooseheading": "Wide Range of Luxury and Premium Vehicles",
      "WhyChoosedescription": "Luxury car rental services in Pune include premium brands like Mercedes-Benz, BMW, Audi, and high-end SUVs, ensuring elegance, performance, and comfort for every journey. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Perfect for Corporate and Executive Travel",
      "WhyChoosedescription": "Luxury rentals are ideal for business meetings, airport transfers, corporate events, and VIP travel, offering a professional and impressive travel experience for clients and executives."
    },
    {
      "WhyChooseheading": "Chauffeur-Driven Luxury Experience",
      "WhyChoosedescription": "Professional, trained chauffeurs ensure a smooth, safe, and sophisticated journey with top-class service standards and excellent knowledge of Pune routes. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Every Occasion",
      "WhyChoosedescription": "Luxury car rental providers offer hourly, daily, and long-term rental options, making it convenient for both short business trips and extended travel needs."
    },
    {
      "WhyChooseheading": "High-End Comfort, Safety, and Features",
      "WhyChoosedescription": "Luxury vehicles come equipped with advanced features, plush interiors, and superior comfort, ensuring a relaxing and premium travel experience. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Ideal for Events, Weddings, and VIP Transfers",
      "WhyChoosedescription": "Luxury car rentals in Pune are widely used for weddings, corporate events, and high-profile occasions, adding prestige and elegance to every journey. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "24/7 Availability with Reliable Support",
      "WhyChoosedescription": "Luxury car rental services operate round the clock, ensuring availability for airport transfers, late-night travel, and urgent business requirements. :contentReference[oaicite:4]{index=4}"
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is luxury car rental in Pune?',
            answer: 'Luxury car rental in Pune provides high-end vehicles like BMW, Mercedes, and Audi with chauffeur-driven services for premium travel experiences.',
        },
        {
            question: 'Which luxury cars are available for rent in Pune?',
            answer: 'You can choose from vehicles like Mercedes-Benz, BMW, Audi, Jaguar, and luxury SUVs depending on your travel needs. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Are luxury car rentals suitable for corporate travel?',
            answer: 'Yes, luxury cars are ideal for corporate travel, executive meetings, airport transfers, and VIP client transportation.',
        },
        {
            question: 'Do luxury car rentals include drivers?',
            answer: 'Yes, most luxury car rental services in Pune provide professional chauffeur-driven vehicles for a premium experience.',
        },
        {
            question: 'Can I book a luxury car for weddings or events?',
            answer: 'Yes, luxury car rentals are widely used for weddings, corporate events, and special occasions.',
        },
        {
            question: 'Are luxury car rental services available 24/7 in Pune?',
            answer: 'Yes, most providers offer round-the-clock services for convenience and flexibility. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Is luxury car rental safe in Pune?',
            answer: 'Yes, services include verified drivers, well-maintained vehicles, and safety protocols for secure travel.',
        },
        {
            question: 'Can I rent luxury cars for outstation travel from Pune?',
            answer: 'Yes, luxury cars are available for both local and outstation trips including one-way and round-trip options.',
        },
        {
            question: 'Do luxury car rental services offer flexible booking plans?',
            answer: 'Yes, providers offer hourly, daily, and long-term rental packages for different travel needs.',
        },
        {
            question: 'How can I book a luxury car rental in Pune?',
            answer: 'You can book online through the service provider’s website or contact their support team for quick reservations.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Mehta',
        designation: 'Business Consultant, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s luxury car rental in Pune gave me a truly premium experience. The car was immaculate, and the chauffeur was highly professional.”',
    },
    {
        name: 'Ms. Anjali Verma',
        designation: 'Event Manager, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked luxury cars for a corporate event, and eTravo exceeded expectations. The service, comfort, and presentation were outstanding.”',
    },
];









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Luxury Car Rentals in Pune",
//   "image": [
//     "https://www.etravo.in/images/keyword/luxury-car-rental-pune.jpg"
//   ],
//   "description": "Premium luxury car rental services in Pune by eTravo. Choose from high-end sedans, SUVs, and executive cars for corporate travel, weddings, VIP transport, and special occasions with top-class comfort.",
//   "brand": {
//     "@type": "Brand",
//     "name": "eTravo"
//   },
//   "sku": "LUXURY-CAR-RENTAL-PUNE",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "ratingValue": "4.7",
//     "ratingCount": "1250",
//     "bestRating": "5",
//     "worstRating": "1"
//   },
//   "offers": {
//     "@type": "Offer",
//     "url": "https://www.etravo.in/luxury-car-rentals-in-pune",
//     "priceCurrency": "INR",
//     "price": "2199",
//     "availability": "https://schema.org/InStock",
//     "itemCondition": "https://schema.org/NewCondition"
//   }
// };



const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Car Rental in Pune",
  "serviceType": "Luxury Car Rental",
  "description":
    "Luxury car rental services in Pune for weddings, business travel, airport transfers, executive travel, corporate events, and special occasions.",
  "provider": {
    "@type": "Organization",
    "name": "eTravo",
    "url": "https://www.etravo.in/"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "url": "https://www.etravo.in/luxury-car-rental-in-pune"
};



    return (
        <div>
            
<Helmet>
  {/* Primary SEO */}
  <title>
    Luxury Car Rental in Pune | Premium & Executive Cars | eTravo
  </title>

  <meta
    name="description"
    content="Book luxury car rental in Pune with eTravo for weddings, business travel, airport transfers, executive rides, events and special occasions."
  />

  <meta
    name="keywords"
    content="luxury car rental in Pune, luxury car rentals in Pune, luxury car hire Pune, premium car rental Pune, executive car rental Pune, luxury chauffeur car Pune"
  />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://www.etravo.in/luxury-car-rental-in-pune"
  />

  {/* Robots */}
  <meta
    name="robots"
    content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Luxury Car Rental in Pune | Premium & Executive Cars | eTravo"
  />

  <meta
    property="og:description"
    content="Book luxury car rental in Pune for weddings, business travel, airport transfers, executive rides, events and special occasions with eTravo."
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:url"
    content="https://www.etravo.in/luxury-car-rental-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.etravo.in/images/keyword/luxury-car-rental-in-pune.jpg"
  />

  <meta
    property="og:image:alt"
    content="Luxury car rental in Pune"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Luxury Car Rental in Pune | Premium & Executive Cars | eTravo"
  />

  <meta
    name="twitter:description"
    content="Book luxury car rental in Pune for business travel, weddings, airport transfers, executive rides and special occasions."
  />

  <meta
    name="twitter:image"
    content="https://www.etravo.in/images/keyword/luxury-car-rental-in-pune.jpg"
  />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Luxury Car Rentals in Pune | Premium & VIP Car Hire Services | eTravo
  </title>

  <meta
    name="description"
    content="Book luxury car rentals in Pune with eTravo for premium sedans, SUVs, corporate travel, weddings, and VIP transport. Experience high-end comfort and reliable service."
  />

  <link
    rel="canonical"
    href="https://www.etravo.in/luxury-car-rentals-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/luxury-car-rental-in-pune.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurycarrentalinpune;